var t = {
  d: (e, r) => {
    for (var a in r) t.o(r, a) && !t.o(e, a) && Object.defineProperty(e, a, {
      enumerable: !0,
      get: r[a]
    });
  },
  o: (t, e) => Object.prototype.hasOwnProperty.call(t, e)
};
(() => {
  var e;
  if ("string" == typeof import.meta.url && (e = import.meta.url), !e) throw new Error("Automatic publicPath is not supported in this browser");
  e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), t.p = e;
})();
var e = {};
t.d(e, {
  J: () => c
});
const r = require("react"),
  a = require("uitk-react-utils"),
  o = require("uitk-react-button"),
  s = t.p + "./styles/egds-sponsored-content-button-custom-extra-small-with-icon.css",
  n = a.classNames.bind(s);
class c extends r.Component {
  static displayName = "ButtonCustomExtraSmallWithIcon";
  render() {
    const {
        props: t
      } = this,
      e = (0, a.classNames)(n("button-custom-extra-small-with-icon", t.className));
    return r.createElement(o.UitkButton, {
      ...t,
      className: e
    });
  }
}
var i = e.J;
export { i as ButtonCustomExtraSmallWithIcon };